/**
 * Removes the `hidden` class from this element when
 * a Stimulus action fires `reveal`. Pair with a
 * window-scoped action and you've got a "show me
 * once X happens" affordance with zero JS in the
 * caller.
 *
 * @example
 * ```html
 * <div class="hidden"
 *      data-controller="reveal-on-event"
 *      data-action="address-selector:addressSelected@window->reveal-on-event#reveal">
 *   I appear after the addressSelected event fires.
 * </div>
 * ```
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  reveal() {
    this.element.classList.remove("hidden");
  }
}
